import { useContext } from "react"
import { AppUIContext } from "./AppUIContext"

export const useAppUI = () => {
  const values = useContext(AppUIContext)
  return values
}
